import { render, staticRenderFns } from "./person_list.vue?vue&type=template&id=27971674&scoped=true"
import script from "./person_list.vue?vue&type=script&lang=js"
export * from "./person_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27971674",
  null
  
)

export default component.exports